import { useSeo } from "@/lib/site";
import { PageIntro } from "@/components/site/PageIntro";
import { ArticleLibrary } from "@/components/site/ArticleLibrary";

export default function UnderstandingHub() {
  useSeo("Understanding", "Accessible, plain-English education about addiction, behaviour, recovery and the impact on families.");
  return (
    <>
      <PageIntro eyebrow="Understanding" title="Understanding addiction can change how we respond to it." image="/images/friends.jpg" imageAlt="Two people sitting together on a park bench among autumn leaves" testId="understanding-intro">
        <p>Clear, compassionate explanations of what addiction is, why it affects behaviour, and what recovery can look like. Read at your own pace.</p>
        <p className="text-sm">This is general information and is not a substitute for advice from a qualified professional who knows your situation.</p>
      </PageIntro>
      <ArticleLibrary hub="understanding" />
    </>
  );
}
